import i18n from "../i18n";

var selected_language = localStorage.getItem("language");
if (selected_language == '') {
    selected_language = 'en'
    i18n.locale = "en"
}
if (selected_language == "fa") {
    i18n.locale = "fa"
}
export default [
    {
        _name: 'CSidebarNav',
        redirect: '/dashboard/main/costs',
        _children: [
            {

                _name: 'CSidebarNavItem',
                name: "داشبورد",
                to: '/dashboard',
                icon: 'cil-info',
                role: 'Help',
                role_access: 'help',
            },
            {

                _name: 'CSidebarNavItem',
                name: 'کارمندان',
                to: '/dashboard/personnel/list',
                icon: 'cil-info',
                role: 'Help',
                role_access: 'help',
            }, {

                _name: 'CSidebarNavItem',
                name: 'مرخصی کارمندان',
                to: '/dashboard/personnel/personnel-leaves',
                icon: 'cil-info',
                role: 'Help',
                role_access: 'help',
            },
            // **************************

            {

                _name: 'CSidebarNavDropdown',
                name: "حقوق دستمزد",
                route: '/dashboard/payroll',
                icon: 'cil-user',
                role: 'Administrator',

                items: [

                    {
                        name: "ورود خروج کامندان",
                        to: '/dashboard/payroll/present_detail'
                        , role: 'AddPersonal/Person'

                    }, {
                        name: "فیش حقوقی",
                        to: '/dashboard/payroll/receipt'
                        , role: 'AddPersonal/Person'

                    },
                ]
            },
            //**************************8 //**************************8
            {

                _name: 'CSidebarNavItem',
                name: "بارگذاری حضور غیاب",
                to: '/dashboard/base/read-excel',
                icon: 'cil-info',
                role: 'Help',
                role_access: 'help',
            },
            //**************************8

            //**************************8

            {

                _name: 'CSidebarNavItem',
                name: 'تنظیمات',
                route: '/dashboard/base',
                to: '/dashboard/base',
                icon: 'cil-info',
                role: 'Help',
                role_access: 'help',
            },

            //**************************8 //**************************8 //**************************8 //**************************8
            //**************************8 //**************************8


        ]
    }
]
